import AutoDeliveryConfigService from './auto-delivery-config'

export * from './types'
export default AutoDeliveryConfigService
